import { v4 } from 'uuid';

export function uuid() {
  return v4();
}
